import React from "react";

// Bandeau fin « trajet en cours / à venir » collé en haut de l'accueil passager (proposition B).
export default function PinnedTripBanner({ text, onClick, testid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="street-press sticky top-2 z-30 mt-4 flex w-full items-center gap-2.5 overflow-hidden rounded-2xl bg-primary px-3.5 py-2.5 text-left text-primary-foreground street-border-thin street-shadow-sm animate-in fade-in slide-in-from-top-2 duration-300"
      data-testid={testid}
    >
      <span className="relative flex h-2.5 w-2.5 flex-none">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/80" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-white" />
      </span>
      <span className="min-w-0 flex-1 truncate text-[13px] font-black">{text}</span>
      <span className="flex-none rounded-full bg-white px-3 py-1 text-[12px] font-black text-foreground street-border-thin">Voir</span>
      <span className="absolute inset-x-0 bottom-0 h-1 bg-white/25">
        <span className="block h-full w-1/3 animate-[pulse_2s_ease-in-out_infinite] bg-white/80" />
      </span>
    </button>
  );
}
